<template lang="pug">
  vm-row(vm-w=12 vm-type="flex" vm-justify="center" vm-align="center")
    vm-col.card.pad.p-0(vm-w=12)
      h2 {{ title }}
      vm-row(vm-w=12 vm-type="flex" vm-justify="center" vm-align="center")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            span.label-span {{ $t("prices.corner_or_park") }}
            money.form-money(v-model="newRecord.price.price_in_front_of_park" v-bind='money' :placeholder='$t("prices.placeholder_extra_cost")')
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            span.label-span {{ $t("prices.apart_cost") }}
            money.form-money(v-model="newRecord.price.reservation_price" v-bind='money' :placeholder='$t("prices.placeholder_apart_cost")' :label='$t("prices.apart_cost")')
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            span.label-span {{ $t("prices.surplus_price") }}
            money.form-money(v-model="newRecord.price.surplus_price" v-bind='money' :placeholder='$t("prices.placeholder_surplus_price")' :label='$t("prices.surplus_price")')
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            span.label-span {{ $t("prices.from_price") }}
            money.form-money(v-model='newRecord.price.from_price' v-bind='money' :placeholder='$t("prices.placeholder_from_price")')
        vm-col(vm-type="flex" vm-align="center" vm-justify="center" vm-w=12)
          vm-button.btn(icon="refresh-outline" @click="saveRecord") {{ $t('Actualizar') }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Prices')

export default {
  name: 'CostUpdater',
  props: {
    title: {
      default: 'Sample Card Text',
      type: String
    },
    newRecord: {
      type: Object
    }
  },
  data: () => ({
    currency_money: '0.00',
    money: {
      thousands: ',',
      prefix: '$',
      suffix: '',
      precision: 0,
      masked: false
    }
  }),
  computed: {
    ...mapGetters([
      'prices',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('prices.' + column)}` : `${str} ${t.$t('prices.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.price'), columns: concatColumns, column: this.$t('prices.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  async created () {
    // await this.loadCategoriesCatalog()
    await this.getPrices(1).then(
      this.initAmount(),
      this.initPark()
    )
  },
  methods: {
    ...mapActions([
      'deletePrice',
      'deletePrices',
      'loadPrices',
      'loadCatalog',
      'getPricesCatalog',
      'editPrice',
      'addPrice',
      'actionPrice',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    initAmount () {
      this.currency_money = this.newRecord.price.from_price
    },
    initPark () {
      this.currency_money = this.newRecord.price.price_in_front_of_park
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    saveRecord () {
      if (this.newRecord.price && (this.newRecord.price.in_front_of_park || this.newRecord.price.reservation_cost || this.newRecord.price.discount_voucher || this.newRecord.price.from_price)) {
        return this.editPrice(this.newRecord.price)
      }
      return this.addPrice(this.newRecord)
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.prices.findIndex(u => u.id === this.selected[0].id)
      this.editPrice(this.selected[0], idx)
    },
    addPrice () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    async deletePriceConfirm (price) {
      let t = this
      this.auxDeletePrice = () => {
        t.deletePrice(price).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.'), attribute: this.$t(price.id/* columna */) }),
        accept: this.auxDeletePrice
      })
    },
    async setActionPrice (record, action) {
      record.id && this.actionPrice({ id: record.id, action })
    },
    async getPrices (page) {
      let t = this
      this.loadPrices({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let price = this.prices.filter(price => price.id === parseInt(index))[0]
      price && this.editPrice(price, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pad {
  padding: 20px !important;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}

.crud .heading .vm-col:first-child div:last-child {
  padding: 0 !important;
}
.btn {
    margin-top: 10px !important;
}
.form-money {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0);
  color: inherit;
  position: relative;
  padding: .4rem;
  border-radius: 5px;
  border: 1px solid transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 2px 8px 0 rgba(59,65,94,.1),0 1px 1px 0 rgba(0,0,0,.07);
  box-shadow: 0 2px 8px 0 rgba(59,65,94,.1),0 1px 1px 0 rgba(0,0,0,.07);
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  width: 100%;
}
.label-span {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(0,0,0,.7);
}
</style>
